
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import convergence from "../../assets/images/convergence.png";
import acmeCorp from "../../assets/images/acme-corp.png";
import frequencii from "../../assets/images/frequencii.png";
import ikigaiLabs from "../../assets/images/ikigai-labs.png";
import degrees from "../../assets/images/degrees.png";
import coder from "../../assets/images/codecraft.png";


const CompanyLogosSlider = () => {
  const settings = {
    centerPadding: "0",
    dots: false,
    navigator: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 5,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const logos = [
    { name: "Convergence", src: convergence },
    { name: "Acme Corp", src: acmeCorp },
    { name: "Frequencii", src: frequencii },
    { name: "Ikigai Labs", src: ikigaiLabs },
    { name: "45 Degrees", src: degrees },
    { name: "Coder", src: coder },
  ];

  return (
    <>
      <div className="company-logo-slider pt-20 pt-sm-25 pt-md-33 pt-lg-42 overflow-x-hidden">
        <Slider {...settings}>
          {logos.map((logo, index) => (
            <div
              key={index}
              className="d-flex justify-content-center align-items-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="object-contain img-fluid"
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default CompanyLogosSlider;